module.exports = __webpack_public_path__ + "media/images/card1-99f075139b8f0cb2822380fd793228b8.jpg";